import React from "react";
import { Route, Switch, Link, BrowserRouter as Router } from "react-router-dom";
import Login from "../views/admin/login";
import PageNotFound from "../views/pageNotFound";

import HomeConnected from "../views/frontend/dashboard";
import CustomPage from "../views/frontend/dashboard/CustomPage";
import AdminConnected from "../views/admin/home";
import ForgotPassword from "../views/admin/forgotPassword";
import ResetPassword from "../views/admin/resetPassword";

import ViewDetail from "../views/frontend/dashboard/ViewDetail";
import ProductDetail from "../views/frontend/dashboard/ProductDetail";
import Product from "../views/frontend/dashboard/Product";
import AuctionDetail from "../views/frontend/dashboard/AuctionDetail";
import Auction from "../views/frontend/dashboard/Auction";
import Cart from "../views/frontend/dashboard/Cart";
import Checkout from "../views/frontend/dashboard/Checkout";
import Register from "../views/frontend/user/Register";
import MyAccount from "../views/frontend/user/MyAccount";
import Voucher from "../views/frontend/user/Voucher";
import VoucherArchive from "../views/frontend/user/VoucherArchive";
import AllDeal from "../views/frontend/dashboard/Alldeal";
import MerchantDirectory from "../views/frontend/dashboard/MerchantDirectory";
import SearchDeal from "../views/frontend/dashboard/SearchDeal";
import TermsAndCondition from "../views/frontend/dashboard/TermsAndCondition";
import ContactUs from "../views/frontend/dashboard/ContactUs";
import PrivacyPolicy from "../views/frontend/dashboard/PrivacyPolicy";
import AboutUs from "../views/frontend/dashboard/AboutUs";
import Partner from "../views/frontend/Partner/Partner";
import Proposal from "../views/frontend/Proposal/Proposal";
import OrderStatus from "../views/frontend/user/OrderStatus";
import Subscription from "../views/frontend/subscription/Subscription";
import Unsubscription from "../views/frontend/subscription/Unsubscription";
import FAQ from "../views/frontend/dashboard/Faq";
import GiftVoucher from "../views/frontend/dashboard/GiftVoucher";
import Redeem from "../views/frontend/user/Redeem";
import GiftRedeem from "../views/frontend/user/GiftRedeem";
import SampleVoucher from "../views/merchant/voucher/SampleVoucher";
import DeleteUser from "../views/frontend/user/DeleteUser";

let siteDDBStatus = JSON.parse(localStorage.getItem("siteDDBStatus"));
export default {
  home: {
    component: HomeConnected,
    path: "/",
  },
  custompage: {
    component: CustomPage,
    path: "/page/:permalink?",
  },
  "city-deal": {
    component: HomeConnected,
    path: "/city-deal/:cityID?",
  },
  "deal-detail": {
    component: ViewDetail,
    path: "/deals-detail/:dealID?/:cityID?/:affiliateID?",
  },
  "deal-detail-id": {
    component: ViewDetail,
    path: "/deals-detail/:dealID?",
  },
  "store-detail": {
    component: ProductDetail,
    path: "/store-detail/:dealID?/:cityID?/:affiliateID?",
  },
  "store-detail-id": {
    component: ProductDetail,
    path: "/store-detail/:dealID?",
  },
  store: {
    component: Product,
    path: "/store/:merchantID?",
  },
  "auction-detail": {
    component: AuctionDetail,
    path: "/auction-detail/:dealID?/:cityID?/:affiliateID?",
  },
  "auction-detail-id": {
    component: AuctionDetail,
    path: "/auction-detail/:dealID?",
  },
  auction: {
    component: Auction,
    path: "/auction/:merchantID?",
  },
  referral: {
    component: HomeConnected,
    path: "/referral/:user_ID?",
  },
  cart: {
    component: Cart,
    path: "/cart/",
  },
  checkout: {
    component: Checkout,
    path: "/checkout/",
  },
  PayPalPayment: {
    component: Checkout,
    path: "/checkout/PayPalPayment",
  },
  register: {
    component: Register,
    path: "/register/",
  },
  MyAccount: {
    component: MyAccount,
    path: "/my-account/",
  },
  voucher: {
    component: Voucher,
    path: "/voucher/:voucherID?/:type?",
  },
  voucherarchive: {
    component: VoucherArchive,
    path: "/voucherarchive/:voucherID?/:type?",
  },
  AllDeal: {
    component: AllDeal,
    path: "/all-deal/:permalink?/",
  },
  MerchantDirectory: {
    component: MerchantDirectory,
    path: "/merchant/",
  },
  SearchDeal: {
    component: SearchDeal,
    path: "/search-deal/:searchText?",
  },
  TermsAndCondition: {
    component: TermsAndCondition,
    path: "/termsAndCondition",
  },
  ContactUs: {
    component: ContactUs,
    path: "/contactUs",
  },
  PrivacyPolicy: {
    component: PrivacyPolicy,
    path: "/privacyPolicy",
  },
  AboutUs: {
    component: AboutUs,
    path: "/aboutUs",
  },
  Login: {
    component: Login,
    path: "/login",
  },
  ForgotPassword: {
    component: ForgotPassword,
    path: "/forgot",
  },
  ResetPassword: {
    component: ResetPassword,
    path: "/resetpassword",
  },
  resetPassword: {
    component: ResetPassword,
    path: "/resetpassword/:token?",
  },
  AdminConnected: {
    component: AdminConnected,
    path: "/dashboard/:userid/:usertype?",
  },
  Partner: {
    component: Partner,
    path: "/become-partner",
  },
  Proposal: {
    component: Proposal,
    path: "/proposal/:contractID?",
  },
  OrderStatus: {
    component: OrderStatus,
    path: "/order/status",
  },
  Subscription: {
    component: Subscription,
    path: "/subscription-manager",
  },
  Unsubscription: {
    component: Unsubscription,
    path: "/subscription/manage",
  },
  FAQ: {
    component: FAQ,
    path: "/faq",
  },
  GiftVoucher: {
    component: GiftVoucher,
    path: "/gift-voucher",
  },
  Redeem: {
    component: Redeem,
    path: "/redeem/:voucherID?",
  },
  GiftRedeem: {
    component: GiftRedeem,
    path: "/gift-redeem/:voucherID?",
  },
  SampleVoucher: {
    component: SampleVoucher,
    path: "/samplevoucher/:dealID?/:userID?",
  },
  DeleteUser: {
    component: DeleteUser,
    path: "/user/delete-user",
  },
};
<Route component={HomeConnected} />;



// WEBPACK FOOTER //
// ./src/app/routes/publicRoutes.js